(() => {
    document.querySelectorAll('.Tabs').forEach(TabRoot => {
        const Triggers = Array.from(TabRoot.querySelectorAll('.TabTrigger'));     // buttons
        const Panels = Array.from(TabRoot.querySelectorAll('.TabContent'));     // panels
        const Container = TabRoot.querySelector('.TabContentWrap');                // height wrapper

        const getH = el => (el ? Math.ceil(el.scrollHeight) : 0);
        const setH = h => { if (Container) Container.style.height = h + 'px'; };

        const setInitialA11y = () => {
            Triggers.forEach(t => {
                t.setAttribute('role', 'tab');
                t.setAttribute('aria-selected', 'false');
                t.tabIndex = -1; // roving tabindex
            });
            Panels.forEach(p => {
                p.setAttribute('role', 'tabpanel');
                p.setAttribute('aria-expanded', 'false');
                p.setAttribute('aria-hidden', 'true');
                p.setAttribute('inert', '');
            });
        };

        const RO = new ResizeObserver(() => {
            const active = TabRoot.querySelector('.TabContent.__active');
            setH(getH(active));
        });
        const observeActive = panel => { RO.disconnect(); if (panel) RO.observe(panel); };

        const activate = trigger => {
            if (!trigger) return;
            const data = trigger.dataset.set;
            const prev = TabRoot.querySelector('.TabContent.__active');
            const next = TabRoot.querySelector(`.TabContent[data-set="${CSS.escape(data)}"]`);

            // lock current height so the transition animates cleanly
            setH(getH(prev || next));

            // update triggers
            Triggers.forEach(t => {
                const on = t === trigger;
                t.classList.toggle('__active', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                t.tabIndex = on ? 0 : -1;
            });

            // swap panels
            if (prev) {
                prev.classList.remove('__active');
                prev.setAttribute('aria-expanded', 'false');
                prev.setAttribute('aria-hidden', 'true');
                prev.setAttribute('inert', '');
            }
            if (next) {
                next.classList.add('__active');
                next.setAttribute('aria-expanded', 'true');
                next.setAttribute('aria-hidden', 'false');
                next.removeAttribute('inert');

                // measure after layout updates to the new active panel
                requestAnimationFrame(() => setH(getH(next)));
                observeActive(next);
            }
        };

        // init
        setInitialA11y();
        if (Triggers[0] && Panels[0]) {
            Triggers[0].tabIndex = 0;
            Triggers[0].classList.add('__active');
            Triggers[0].setAttribute('aria-selected', 'true');

            Panels[0].classList.add('__active');
            Panels[0].setAttribute('aria-expanded', 'true');
            Panels[0].setAttribute('aria-hidden', 'false');
            Panels[0].removeAttribute('inert');

            setH(getH(Panels[0]));
            observeActive(Panels[0]);
        }

        // click to activate
        TabRoot.addEventListener('click', evt => {
            const btn = evt.target.closest('.TabTrigger');
            if (!btn || !TabRoot.contains(btn)) return;
            evt.preventDefault();
            activate(btn);
            btn.focus();
        });

        // keyboard navigation per WAI-ARIA tabs pattern
        TabRoot.addEventListener('keydown', evt => {
            const current = document.activeElement.closest('.TabTrigger');
            if (!current) return;

            const i = Triggers.indexOf(current);
            let nextIndex = i;

            if (evt.key === 'Enter' || evt.key === ' ') {
                evt.preventDefault();
                activate(current);
                return;
            }
            if (evt.key === 'ArrowRight' || evt.key === 'ArrowDown') {
                evt.preventDefault();
                nextIndex = (i + 1) % Triggers.length;
            } else if (evt.key === 'ArrowLeft' || evt.key === 'ArrowUp') {
                evt.preventDefault();
                nextIndex = (i - 1 + Triggers.length) % Triggers.length;
            } else if (evt.key === 'Home') {
                evt.preventDefault();
                nextIndex = 0;
            } else if (evt.key === 'End') {
                evt.preventDefault();
                nextIndex = Triggers.length - 1;
            } else {
                return;
            }
            Triggers[nextIndex].focus();
        });

        // keep height accurate on window resize
        let rafId;
        window.addEventListener('resize', () => {
            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                const active = TabRoot.querySelector('.TabContent.__active');
                setH(getH(active));
            });
        });
    });
})();
